'use client';

import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import dynamic from 'next/dynamic';

// Using the fixed version without framer-motion to avoid webpack errors
const SearchModalModernFixed = dynamic(() => import('./SearchModalModernFixed'), {
  loading: () => null,
  ssr: false
});

interface SearchModalPortalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function SearchModalPortal({ isOpen, onClose }: SearchModalPortalProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (!mounted) return null;

  return createPortal(
    <SearchModalModernFixed isOpen={isOpen} onClose={onClose} />,
    document.body
  );
}